import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import "../../../assets/scss/print-load.scss";
import { BulkLoadPreviewData } from "./BulkLoadPreviewData";

const BulkLoadPrint = (props) => {
  const { loadList, previewFormData } = props;

  const componentRef = useRef();
  const pageStyle = `
    @page{
        padding: 10px;
    }`;
  return (
    <>
      <Modal.Body className="preview-body multi-preview-body">
        <div ref={componentRef}>
          {loadList.map((load, index) => (
            <React.Fragment key={index}>
              <BulkLoadPreviewData load={load} previewFormData={previewFormData} loadCount={loadList.length} currentIdx={index} />
              {loadList.length > 0 && (
                <div className="preview-spacing"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="preview-footer">
        <ReactToPrint
          trigger={() => <Button>Print</Button>}
          content={() => componentRef.current}
          pageStyle={pageStyle}
        />
      </Modal.Footer>
    </>
  );
};

export default BulkLoadPrint;